var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "New Issues Flow"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7009 -822C-7009 -823.105 -7008.1 -824 -7007 -824H22017C22018.1 -824 22019 -823.105 22019 -822V1188C22019 1189.1 22018.1 1190 22017 1190H-7007C-7008.1 1190 -7009 1189.1 -7009 1188V-822Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7007 -823H22017V-825H-7007V-823ZM22018 -822V1188H22020V-822H22018ZM22017 1189H-7007V1191H22017V1189ZM-7008 1188V-822H-7010V1188H-7008ZM-7007 1189C-7007.55 1189 -7008 1188.55 -7008 1188H-7010C-7010 1189.66 -7008.66 1191 -7007 1191V1189ZM22018 1188C22018 1188.55 22017.6 1189 22017 1189V1191C22018.7 1191 22020 1189.66 22020 1188H22018ZM22017 -823C22017.6 -823 22018 -822.552 22018 -822H22020C22020 -823.657 22018.7 -825 22017 -825V-823ZM-7007 -825C-7008.66 -825 -7010 -823.657 -7010 -822H-7008C-7008 -822.552 -7007.55 -823 -7007 -823V-825Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "New issue dropdown"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 768,
    transform: "translate(-1222 -99)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34625294",
    x: -1222,
    y: -34,
    width: 1280,
    height: 88,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224335",
    clipPath: "url(#clip0_1001_103642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002786"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -160.5,
    y: -9.5,
    width: 194,
    height: 44,
    rx: 7.5,
    stroke: "#D8D9DF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chevron_right"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1001_103642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 24.5,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1001_103642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_2",
    d: "M12 11.9L7.4 16.5L6 15.1L12 9.1L18 15.1L16.6 16.5L12 11.9Z",
    fill: "#40414C"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_103642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1026,
    height: 581,
    fill: "white",
    transform: "translate(-992 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.fa1c061830216297bd55a98f0d98bef8.svg";
export { ForwardRef as ReactComponent };